import { render, staticRenderFns } from "./SupplierHaulierDetails.vue?vue&type=template&id=3b754756&scoped=true&"
import script from "./SupplierHaulierDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierHaulierDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupplierHaulierDetails.vue?vue&type=style&index=0&id=3b754756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b754756",
  null
  
)

export default component.exports